/** Phase B · counterparty tax flags; which fields show is decided by the country schema (/contacts/tax-attributes-schema). */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { API } from '../../App';

export const ContactTaxAttributes = ({ value = {}, onChange, contactType }) => {
  const [schema, setSchema] = useState(null);
  useEffect(() => { axios.get(`${API}/contacts/tax-attributes-schema`).then((r) => setSchema(r.data)).catch(() => {}); }, []);
  if (!schema) return null;
  const set = (k, v) => onChange({ ...value, [k]: v });
  const visible = (f) => (!f.contact_types || !contactType || contactType === 'other' || f.contact_types.includes(contactType))
    && (!f.show_if || Object.entries(f.show_if).every(([k, vals]) => vals.includes(value[k])));
  return (
    <div className="space-y-3 rounded-xl border border-slate-200 p-4" data-testid="contact-tax-attributes">
      <div>
        <p className="font-medium text-sm">Tax attributes ({schema.country})</p>
        <p className="text-xs text-muted-foreground">Used by the tax engine on every invoice, bill and bank-feed row with this contact.</p>
      </div>
      {schema.fields.filter(visible).map((f) => (
        <div key={f.id} className={f.type === 'bool' ? 'flex items-center justify-between gap-3' : 'space-y-1'} data-testid={`contact-tax-${f.id}`}>
          <Label className="text-sm">{f.label}</Label>
          {f.type === 'bool' && <Switch checked={!!value[f.id]} onCheckedChange={(v) => set(f.id, v)} data-testid={`contact-tax-${f.id}-switch`} />}
          {f.type === 'text' && <Input value={value[f.id] || ''} onChange={(e) => set(f.id, e.target.value)} data-testid={`contact-tax-${f.id}-input`} />}
          {f.type === 'single' && (
            <Select value={value[f.id] || ''} onValueChange={(v) => set(f.id, v)}>
              <SelectTrigger data-testid={`contact-tax-${f.id}-select`}><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>{f.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
            </Select>
          )}
        </div>
      ))}
    </div>
  );
};
